import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardApiService } from './db-api.service';

@Injectable({
  providedIn: 'root',
})
export class NameChangeRequestsApiService extends DashboardApiService {
  getNameChangeRequestsCount(): Observable<number> {
    return this._get(
      `/v1/issuer/organizations/${this.embedding.departmentId}/recipient_name_change_requests/count`,
    ).pipe(
      map((res) => this._handleResponse(res, 'recipient_name_change_requests', 'count')),
      catchError((res) => this._handleError(res)),
    );
  }
}
